import { motion } from "framer-motion";

export const SunShape = () => (
  <g>
    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
      <line
        key={a}
        x1="0"
        y1="-46"
        x2="0"
        y2="-58"
        stroke="#FCD34D"
        strokeWidth="6"
        strokeLinecap="round"
        transform={`rotate(${a})`}
      />
    ))}
    <circle cx="0" cy="0" r="34" fill="#FCD34D" />
    <circle cx="0" cy="0" r="26" fill="#FDE68A" />
  </g>
);

export const CloudShape = () => (
  <g fill="#FFFFFF">
    <ellipse cx="0" cy="0" rx="34" ry="18" />
    <ellipse cx="26" cy="-9" rx="24" ry="15" />
    <ellipse cx="-24" cy="-7" rx="20" ry="13" />
  </g>
);

export const Tree = ({ x, y, scale = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <rect x="-4" y="0" width="8" height="28" rx="3" fill="#92400E" />
    <circle cx="0" cy="-16" r="22" fill="#34D399" />
    <circle cx="-15" cy="-3" r="14" fill="#6EE7B7" />
    <circle cx="15" cy="-5" r="15" fill="#10B981" />
  </g>
);

export const Cone = ({ x, y, scale = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${scale})`}>
    <path d="M7 0 L15 34 L-1 34 Z" fill="#F97316" />
    <path d="M2.6 17 L11.4 17 L13.2 25 L0.8 25 Z" fill="#FFFFFF" />
    <rect x="-5" y="34" width="24" height="6" rx="3" fill="#EA580C" />
  </g>
);

export const TrafficLight = ({ x, y }) => (
  <g transform={`translate(${x} ${y})`}>
    <rect x="17" y="82" width="6" height="118" rx="3" fill="#475569" />
    <rect x="0" y="0" width="40" height="88" rx="12" fill="#1E293B" />
    <circle cx="20" cy="19" r="9" fill="#EF4444" opacity="0.35" />
    <circle cx="20" cy="44" r="9" fill="#FBBF24" opacity="0.35" />
    <motion.circle
      cx="20"
      cy="69"
      r="9"
      fill="#22C55E"
      animate={{ opacity: [1, 0.45, 1] }}
      transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
    />
  </g>
);

export const LPlateMark = () => (
  <g>
    <rect x="1" y="1" width="64" height="64" rx="10" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="2" />
    <text
      x="33"
      y="46"
      textAnchor="middle"
      fontSize="38"
      fontWeight="800"
      fill="#DC2626"
      fontFamily="Outfit, sans-serif"
    >
      L
    </text>
  </g>
);

export const LPlateSign = ({ x, y }) => (
  <g transform={`translate(${x} ${y})`}>
    <rect x="30" y="60" width="6" height="106" rx="3" fill="#475569" />
    <LPlateMark />
  </g>
);

export const ArrowSign = ({ x, y }) => (
  <g transform={`translate(${x} ${y})`}>
    <rect x="-3" y="26" width="6" height="110" rx="3" fill="#475569" />
    <circle cx="0" cy="0" r="26" fill="#2563EB" stroke="#FFFFFF" strokeWidth="4" />
    <path
      d="M-10 0 H9 M2 -7 L9 0 L2 7"
      stroke="#FFFFFF"
      strokeWidth="4"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>
);

export const PinPoint = ({ x, y }) => (
  <g transform={`translate(${x} ${y})`}>
    <ellipse cx="0" cy="48" rx="16" ry="5" fill="#2563EB" opacity="0.15" />
    <motion.g
      animate={{ y: [0, -10, 0] }}
      transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
    >
      <path
        d="M0 44 C-6 34 -26 22 -26 2 C-26 -12 -14 -24 0 -24 C14 -24 26 -12 26 2 C26 22 6 34 0 44 Z"
        fill="#2563EB"
      />
      <circle cx="0" cy="0" r="10" fill="#FFFFFF" />
    </motion.g>
  </g>
);

export const Sparkle = ({ x, y, delay = 0 }) => (
  <g transform={`translate(${x} ${y})`}>
    <motion.circle
      cx="0"
      cy="0"
      r="4"
      fill="#93C5FD"
      animate={{ opacity: [0.2, 1, 0.2], scale: [0.7, 1.25, 0.7] }}
      transition={{ duration: 2.6, repeat: Infinity, delay, ease: "easeInOut" }}
    />
  </g>
);

const Wheel = ({ cx }) => (
  <g transform={`translate(${cx} 102)`}>
    <motion.g
      animate={{ rotate: 360 }}
      transition={{ duration: 2.6, repeat: Infinity, ease: "linear" }}
    >
      <circle cx="0" cy="0" r="21" fill="#1E293B" />
      <circle cx="0" cy="0" r="9" fill="#F8FAFC" />
      <path d="M0 -8 V8 M-8 0 H8" stroke="#94A3B8" strokeWidth="3" />
    </motion.g>
  </g>
);

export const CarBody = () => (
  <g>
    <ellipse cx="118" cy="113" rx="104" ry="10" fill="#0F172A" opacity="0.08" />
    <path d="M62 54 C68 26 88 12 112 12 L142 12 C164 12 178 28 184 54 Z" fill="#2563EB" />
    <path d="M74 50 C79 32 92 22 110 22 L110 50 Z" fill="#DBEAFE" />
    <path d="M118 22 L140 22 C156 22 166 32 172 50 L118 50 Z" fill="#DBEAFE" />
    <ellipse cx="135" cy="35" rx="5.5" ry="6.5" fill="#FFFFFF" />
    <ellipse cx="153" cy="35" rx="5.5" ry="6.5" fill="#FFFFFF" />
    <circle cx="136.5" cy="36" r="2.6" fill="#1E293B" />
    <circle cx="154.5" cy="36" r="2.6" fill="#1E293B" />
    <rect x="16" y="50" width="204" height="52" rx="22" fill="#2563EB" />
    <circle cx="212" cy="70" r="6" fill="#FDE68A" />
    <rect x="14" y="64" width="6" height="12" rx="3" fill="#F87171" />
    <path
      d="M194 84 q9 7 18 0"
      stroke="#1E3A8A"
      strokeWidth="3.5"
      fill="none"
      strokeLinecap="round"
    />
    <rect x="2" y="58" width="20" height="20" rx="5" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth="1.5" />
    <text
      x="12"
      y="73"
      textAnchor="middle"
      fontSize="13"
      fontWeight="800"
      fill="#DC2626"
      fontFamily="Outfit, sans-serif"
    >
      L
    </text>
    <Wheel cx={64} />
    <Wheel cx={172} />
  </g>
);
